import React from 'react';
import PropTypes from 'prop-types';

const OtpTransferSteps = ({ otpSteps }) => {
    return (
        <div className="otp-list">
            {otpSteps.map(otpStep => {
                return (
                    <div key={otpStep.id} className="otp-list-items">
                        <span className="otp-list-id">{otpStep.id}</span>
                        {otpStep.text}
                    </div>
                );
            })}
        </div>
    );
};

OtpTransferSteps.propTypes = {
    otpSteps: PropTypes.array.isRequired,
};

OtpTransferSteps.defaultProps = {
    otpSteps: [],
};

export default OtpTransferSteps;
